import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Footer: React.FC = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <p className="footer-copyright">
          © {currentYear} CypressEra. {t('footer.copyright')}
        </p>
        <div className="footer-links">
          <a href="https://github.com/CypressEra/CypressEra" className="footer-link" target="_blank" rel="noopener noreferrer">GitHub</a>
          <Link to="/privacy" className="footer-link" target="_blank" rel="noopener noreferrer">{t('footer.privacyPolicy')}</Link>
          <Link to="/terms" className="footer-link" target="_blank" rel="noopener noreferrer">{t('footer.termsOfUse')}</Link>
          <a href="mailto:support@cypressera.ai" className="footer-link">{t('footer.contactUs')}</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
